import { ChangeDetectionStrategy, Component, inject } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MAT_DIALOG_DATA, MatDialogModule, MatDialogRef } from '@angular/material/dialog';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { Payment } from '../../../core/models/payment.model';

@Component({
  selector: 'app-payment-delete-dialog',
  standalone: true,
  imports: [CommonModule, MatDialogModule, MatButtonModule, MatIconModule],
  changeDetection: ChangeDetectionStrategy.OnPush,
  templateUrl: './payment-delete-dialog.component.html',
  styleUrl: './payment-delete-dialog.component.scss',
})
export class PaymentDeleteDialogComponent {
  readonly data = inject<{ payment: Payment }>(MAT_DIALOG_DATA);
  readonly dialogRef = inject<MatDialogRef<PaymentDeleteDialogComponent, boolean>>(MatDialogRef);
}
